import { useState } from 'react';
import {
  Button,
  Paper,
} from '@mui/material';
import FilterableMultiSelector from '../../../selector/FilterableMultiSelector';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';
import './ObjectiveFilter.scss';

const ObjectiveFilter = ({
  ...props
}) => {
  const defaultProps = {
    onFilterChange: () => { },
    filterValue: {},
    multiSelectFilterConfig: [],
    children: null,
  };
  const {
    onFilterChange,
    filterValue,
    multiSelectFilterConfig,
    children,
    ...restObjective
  } = { ...defaultProps, ...filterUndefined(props) };
  const [state, setState] = useState({ ...filterValue });

  const setStateAndCallOnchange = (newState) => {
    setState(newState);
    onFilterChange(newState);
  };

  const handleMultiSelectorApply = (keyName, value) => {
    setStateAndCallOnchange({ ...state, [keyName]: value });
  };

  const handleOnClearFilterClick = () => {
    setStateAndCallOnchange({
      archived: false,
      keyword: '',
    });
  };

  return (
    <Paper className='objective-filter' {...restObjective}>
      {multiSelectFilterConfig ? (
        multiSelectFilterConfig.map((config, index) => {
          const { keyName, getValue, ...rest } = config;
          const initFilterValue = state[keyName];
          const initFilterKeyValues = initFilterValue ? initFilterValue.map((v) => v.key) : [];

          return (
            <FilterableMultiSelector
              key={`filter-selector-${config.label}-${index}`}
              onApply={(value) => { handleMultiSelectorApply(keyName, value); }}
              initFilterKeyValues={initFilterKeyValues}
              {...rest}
            />
          );
        })
      ) : null}
      <Button
        className='clear-filter-button'
        onClick={handleOnClearFilterClick}
      >
        Clear Filters
      </Button>
      {children}
    </Paper>
  );
};

export default ObjectiveFilter;
